export default function(connection){
  if(!connection){
    return undefined
  }
  return connection.edges.map((edge) => {
    return edge.node
  })
}



// WEBPACK FOOTER //
// ./src/utils/connectionMapper.js